export default function Marquee({ items, dark = true }) {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden py-6 md:py-8 border-y ${dark ? "bg-ink border-white/10" : "bg-paper border-line"}`} aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee-slow w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display font-bold text-2xl md:text-4xl tracking-tight px-6 md:px-10 display-expanded ${dark ? "text-white/90" : "text-ink"}`}>{item}</span>
            <span className="w-2 h-2 rotate-45 bg-gold inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
